import Article from 'umg-ember-backend/components/record-explorer/for/article';

<template><Article @records={{@model}} @recordType='article' /></template>
